import { BaseModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'
import { fillOwnProperties } from '~/shared/utils/helpers'
import { ImageService } from '~/services/Misc/ImageService'

export default class AgrotechClassPartnerImage extends BaseModel {
  uuid: string = ''
  url: string = ''
  name: string = ''
  'file_size': string = ''
  'sort_index': number = 0

  constructor(data: unknown) {
    super()
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }

  get previewUrl(): string {
    return this.url ? new ImageService().cropImage(this.url, {}) : ''
  }
}
